import { render, staticRenderFns } from "./ScoreSetRounds.vue?vue&type=template&id=4c28ab46"
import script from "./ScoreSetRounds.vue?vue&type=script&lang=js"
export * from "./ScoreSetRounds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports